import { render, staticRenderFns } from "./Forgot-password.vue?vue&type=template&id=50c7b5ae&"
import script from "./Forgot-password.vue?vue&type=script&lang=js&"
export * from "./Forgot-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports